module.exports = __webpack_public_path__ + "assets/img/live20_app.9344cb59.png";